const sectionTracker = {
    init() {
        this.appendTrackerItems();
    },
    setIdSlugToHeadingFromTitle( heading ) {
        const title = heading.innerText;
        const slug = title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
        heading.id = slug;

    },
    appendTrackerItems( heading_level = 2 ) {
        const sectionTrackerWrapper = document.querySelector('.section-tracker');

        if ( ! sectionTrackerWrapper ) {
            return;
        }

        const sectionTrackerElement = sectionTrackerWrapper.querySelector('.section-tracker__list');
        const sections = document.querySelectorAll(`.section-tracker-wrapper h${heading_level}.wp-block-heading`);

        if (sections.length === 0 ) {
            sectionTracker.hideEmptyContainer(sectionTrackerWrapper);
            
            return;
        }
        const trackerItems = [];

        sections.forEach(
            (item) => {
                let sectionID = item.id;

                if ( ! sectionID ) {
                    sectionTracker.setIdSlugToHeadingFromTitle( item );
                }

                sectionID = item.id;

                const sectionTitle = item.innerText;
                const sectionItem = sectionTracker.createNavigationItem(sectionID, sectionTitle);
                trackerItems.push(sectionItem);
            },
        );

        sectionTracker.addItemsToContainerList(trackerItems);
    },
    createNavigationItem(ID, title) {
        const listItem = document.createElement('li');
        const navigationItem = document.createElement('a');

        navigationItem.href = `#${ID}`;
        navigationItem.innerText = title;

        listItem.append(navigationItem);

        return listItem;
    },
    addItemsToContainerList(items) {
        const sectionTrackerElement = document.querySelector('.section-tracker__list');
        if (!sectionTrackerElement) {
            return;
        }
        items.forEach(
            (item) => {
                sectionTrackerElement.append(item);
            },
        );
    },
    hideEmptyContainer(parentElement) {
        if ( ! parentElement ) {
            return;
        }

        parentElement.style.display = 'none';
    }
};

export default sectionTracker;
sectionTracker.init();